<template>
  <div style="background-color: #f5f8fa">
    <!-- <top-title :name="name"></top-title> -->
    <div>
      <!--筛选条件 -->
      <div class="input-form-box">
        <div>
          <input-form
            :orderStatusType="orderStatusType"
            @onSerach="searchForm1"
            ref="inputForm"
          ></input-form>
        </div>
      </div>

      <div class="order-content">
        <div class="btn_wrap">
          <div class="btn_left">
            <el-button
              class="dingdanfasong_button1"
              v-zoom="{ from: pageName, name: '发送短信' }"
              @click="handleBatchSend()"
              style="height: 32px; padding: 0 15px; vertical-align: middle"
              >发送短信</el-button
            >
            <el-button
              @click="handleQueryResults()"
              v-zoom="{ from: pageName, name: '按查询结果发送短信' }"
              class="dingdanfasong_button2"
              style="width: 130px"
              >按查询结果发送</el-button
            >
            <el-button
              @click="handleBatchLabel('1')"
              v-zoom="{ from: pageName, name: '打标签' }"
              class="dingdanfasong_button3"
              >打标签</el-button
            >
            <el-button
              @click="handleBatchLabel('2')"
              v-zoom="{ from: pageName, name: '按查询结果打标签' }"
              class="dingdanfasong_button3"
              style="width: 140px"
              >按查询结果打标签</el-button
            >
            <el-button
              @click="handleCreateCrowd('1')"
              v-zoom="{ from: pageName, name: '生成人群' }"
              class="dingdanfasong_button3"
              >生成人群</el-button
            >
            <el-button
              @click="handleCreateCrowd('2')"
              v-zoom="{ from: pageName, name: '按查询结果生成人群' }"
              class="dingdanfasong_button3"
              style="width: auto"
              >按查询结果生成人群</el-button
            >
          </div>
          <div class="btn_right">
            <!-- <el-button class="dingdanfasong_button2" v-zoom="{ from: pageName, name: '添加订单' }" @click="handleAddOrder">添加订单</el-button> -->
            <el-button
              @click="handleAddBlack"
              v-zoom="{ from: pageName, name: '加入黑名单' }"
              class="dingdanfasong_button3"
              >加入黑名单</el-button
            >
          </div>
        </div>

        <!--tab切换-->
        <!-- <div class="tab-hug clear-float">
          <div
            class="tab-item"
            v-for="(item, index) in orderStatusType"
            :key="index"
            :class="{ active: tabItemActive == index }"
            :style="{
              color: tabItemActive == index ? globalBG : '',
              'border-top-color': tabItemActive == index ? globalBG : '',
            }"
            @click="tabItemBtn(index)"
          >
            {{ item.label }}
          </div>
        </div> -->
        <!-- 订单内容 -->
        <div class="table-content">
          <el-table
            ref="table"
            :data="lists"
            v-loading="tableLoading"
            tooltip-effect="light"
            row-key="orderId"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            @selection-change="handleSelectionChange"
            style="width: 100%; border: 1px solid #eee"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              type="selection"
              reserve-selection
              width="55"
            ></el-table-column>
            <el-table-column
              label="买家账号"
              prop="desensitizePin"
            ></el-table-column>
            <el-table-column label="订单状态" prop="orderStateRemark">
            </el-table-column>
            <el-table-column  v-if="permissions.indexOf('hide:order:presellOrder') ==-1 " label="订单编号" prop="orderId"></el-table-column>
            <el-table-column label="预售ID" prop="presaleId"></el-table-column>
            <el-table-column label="支付类型" prop="orderPayType">
              <template slot-scope="scope">
                {{ scope.row.orderPayType == 1 ? "全款" : "非全款" }}
              </template>
            </el-table-column>
            <el-table-column
              label="预售价格"
              prop="yushouPrice"
            ></el-table-column>
            <el-table-column
              label="定金实际支付"
              prop="payBargainReal"
            ></el-table-column>
            <el-table-column
              label="定金实际时间"
              prop="bargainTime"
            ></el-table-column>
            <el-table-column
              label="尾款实际支付"
              prop="payBalanceReal"
            ></el-table-column>
            <el-table-column
              label="尾款实际时间"
              prop="balanceTime"
            ></el-table-column>
            <el-table-column label="详情" width="60px">
              <template slot-scope="scope">
                <span
                  class="btn"
                  v-zoom="{ from: pageName, name: '查看详情' }"
                  :style="{ color: globalBG }"
                  @click="handleDetail(scope.row, scope.$index)"
                  >查看</span
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              background
              @current-change="handleCurrentChange"
              :current-page="pagination.current"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="pagination.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加订单号弹窗 -->
    <el-dialog
      :visible.sync="addOrderDialog"
      title="添加订单"
      width="582px"
      style="border-bottom-right-radius: 6px"
    >
      <div class="order-line">
        <span>订单号：</span>
        <el-input
          placeholder='多个订单号用 "," 隔开'
          v-model="addOrderForm.orderId"
        ></el-input>
      </div>
      <div class="btn-group">
        <el-button class="b1" @click="addOrderDialog = false">取消</el-button>
        <el-button class="b2" @click="addOrderConfirm">确定</el-button>
      </div>
    </el-dialog>
    <!-- 提示 -->
    <el-dialog :visible.sync="blackListDialog" title="提示" width="400px">
      <div class="tipDialog">
        <i class="el-icon-warning" :style="{ color: globalBG }"></i>
        <span>确定拉黑订单吗？</span>
      </div>
      <div class="btn-group" style="text-align: center">
        <el-button
          :style="{ color: globalBG, 'border-color': globalBG }"
          @click="blackListDialog = false"
          >取消</el-button
        >
        <el-button type="primary" @click="handleInsertBlack">确定</el-button>
      </div>
    </el-dialog>
    <!-- 批量发送短信抽屉 -->
    <!-- <send-sms :drawer="drawer" @close="drawerClose"></send-sms> -->
    <!-- 查看详情弹窗 -->
    <order-detial
      v-if="showDetailDialog"
      @onClose="handleCloseDetail"
      :visibile="showDetailDialog"
      :orderId="checkOrder"
    ></order-detial>

    <!-- 选择标签弹窗 -->
    <!-- <buyer-label-dialog v-if="isShowLabelDialog" :data="dialogLabelIds" @onClose="handleCloseLabel"></buyer-label-dialog> -->

    <!-- 发送短信 -->
    <el-dialog
      :visible="showSendMsg"
      width="1450px"
      custom-class="send-message-box"
      title="发送短信"
      :before-close="handleCloseSendX"
    >
      <send-message-x
        v-if="showSendMsg"
        :sendType="15"
        :preSendType="preSendType"
        @onViewRecord="handleViewRecord"
        @onConSending="handleConSending"
        :conditionParam="conditionParam"
        :signature="1"
        :isOlderSent="true"
      ></send-message-x>
    </el-dialog>

    <!-- 标签选中弹窗 -->
    <select-label
      v-if="isShowLabelDialog"
      @transferName4="handleCloseLabel"
      :labelState="isShowLabelDialog"
      :selectIdsArr="labelListArr"
    ></select-label>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :selectIdsArr="crowdForm"
      :isShowCrowdDialog.sync="isShowCrowdDialog"
    ></crowdDialog>
  </div>
</template>

<script>
import {
  batchAddLabel,
  getCommonBuyerLabel,
  batchAddLabelByQuery,
} from "@/api/shopBuyer";
// import buyerLabelDialog from "@/components/buyer-label-dialog.vue";
import selectLabel from "@/components/select-label.vue";
import crowdDialog from "@/components/crowd-Dialog.vue";
import {
  getTbOrder,
  addOrder,
  sensitive,
  getOrderIds,
  tbOrderPresell,
  Presellpop,
  LabelByQueryPop,
} from "@/api/tbOrder";
import { insertBlack } from "@/api/smsBlackList";
import orderDetial from "./order-detail.vue";
import topTitle from "@/components/top-title.vue";
import inputForm from "./input_form";
import sendMessageX from "@/components/send-message-x";

// import sendSms from '../../views/serviceCenter/components/sendSms'
import { mapState, mapMutations } from "vuex";
let that;
export default {
  name: "order_send",
  components: {
    topTitle,
    inputForm,
    // sendSms,
    orderDetial,
    // buyerLabelDialog,
    sendMessageX,
    selectLabel,
    crowdDialog,
  },
  data() {
    return {
      name: "订单发送",
      pageName: "客户营销-订单发送",
      formData: {},
      tabItemActive: 0,
      tableLoading: false,
      timechage: true,
      orderStatusType: [
        {
          label: "未付定金/全款",
          value: "0",
        },
        {
          label: "定金已付",
          value: "1",
        },
        {
          label: "尾款已付",
          value: "2",
        },
        {
          label: "全款支付完成",
          value: "3",
        },
        {
          label: "未付定金",
          value: "11",
        },
        {
          label: "未付完定金",
          value: "12",
        },
        {
          label: "定金超付",
          value: "13",
        },
        // {
        //   label: "未付尾款",
        //   value: "21",
        // },
        {
          label: "未付完尾款",
          value: "22",
        },
        {
          label: "尾款超付",
          value: "23",
        },

        {
          label: "全款未支付完",
          value: "31",
        },
        {
          label: "全款支付超付",
          value: "33",
        },
        {
          label: "商家违约",
          value: "99",
        },
        {
          label: "取消",
          value: "21,121,131,221,311,990,991,992,993,994,995,1000,1001,2000",
        },
        // {
        //   label: "未付完定金订单取消",
        //   value: "121",
        // },
        // {
        //   label: "定金超付未完成尾款取消",
        //   value: "131",
        // },
        // {
        //   label: "未付完尾款订单取消",
        //   value: "221",
        // },
        // {
        //   label: "全款未支付完订单取消",
        //   value: "311",
        // },
        // {
        //   label: "待付定金商家违约",
        //   value: "990",
        // },
        // {
        //   label: "定金已付商家违约",
        //   value: "991",
        // },
        // {
        //   label: "未付完定金商家违约",
        //   value: "992",
        // },
        // {
        //   label: "定金超付商家违约",
        //   value: "993",
        // },
        // {
        //   label: "未付完尾款商家违约",
        //   value: "994",
        // },
        // {
        //   label: "全款未支付完成商家违约",
        //   value: "995",
        // },
        // {
        //   label: "预售平台取消订单",
        //   value: "1000",
        // },
        // {
        //   label: "预售平台取消订单",
        //   value: "1001",
        // },
        // {
        //   label: "非预售平台取消订单",
        //   value: "2000",
        // },
      ],

      allSelectFlag: false,
      lists: [],
      multipleSelection: [], // 表格多选

      addOrderDialog: false,
      blackListDialog: false,
      checkOrder: "", // 用于查看订单详情的订单id
      pagination: {
        current: 1,
        size: 10,
      },
      total: 0,
      // drawer: false,
      showDetailDialog: false,
      addOrderForm: {
        orderId: "",
      },
      selectList: [],
      isShowLabelDialog: false, // 显示会员标签
      dialogLabelIds: [], // 标签回显

      showSendMsg: false,
      preSendType: 2, // 2.表示勾选 1.表示按查询条件
      conditionParam: {},

      isShowCrowdDialog: false, // 生成人群
      crowdForm: {},

      labelListArr: [], // 公共id
      batchLableType: 1, // 批量打标签 2.按查询结果打标签
      isNavigate: false, // 是否是通过其他页面跳转过来查询
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    permissions() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.permissions;
    }
  },
  created() {
    if (this.$route.query && this.$route.query.focusShop) {
      this.isNavigate = true;
    } else if (this.$route.query && this.$route.query.type) {
      this.isNavigate = true;
    }
  },
  mounted() {
    that = this;
    if (this.$route.query && this.$route.query.focusShop) {
      const data = JSON.parse(this.$route.query.data);
      console.log(data);
      this.$refs.inputForm.formData.pin = data.pin;
      this.$refs.inputForm.submitForm();
    } else if (this.$route.query && this.$route.query.type) {
      const data = this.$route.query;
      console.log(data);
      this.$refs.inputForm.formData.orderStartTimeStart =
        data.moneyPayStartTime;
      this.$refs.inputForm.formData.orderStartTimeEnd = data.moneyPayEndTime;
      this.$refs.inputForm.checkedStatusType = ["22"];
      this.$refs.inputForm.formData.orderState = "22";

      this.$refs.inputForm.submitForm();
    } else {
      // this.getDataList();
    }
  },
  filters: {
    // showOrderStatus(val) {
    //   var temp = that.orderStatusType.find(obj => {
    //      return obj.value == val
    //   })
    //   if (temp) {
    //     return temp.label;
    //   }
    // }
  },
  methods: {
    ...mapMutations(["MODELTITLE"]),
    handleViewRecord() {
      this.$emit("onViewRecord");
    },
    handleCloseSendX() {
      this.showSendMsg = false;
    },
    handleConSending() {
      // 发送成功后的继续发送
      // console.log('handleConSending')
      this.showSendMsg = false;
    },

    // 信息显示全 type 0 手机号码, 1 pin（买家昵称）, 2 买家姓名, 3 地区
    showInfo(type, row, index) {
      var param = {
        orderId: row.orderId,
        type,
      };
      sensitive(param).then((res) => {
        if (res.code == "1") {
          if (type == "1") {
            // pin
            this.lists[index].pin = res.data.pin;
            this.lists[index].pinState = true;
          } else if (type == "2") {
            // 买家姓名
            this.lists[index].fullName = res.data.fullName;
            this.lists[index].fullNameState = true;
          } else if (type == "0") {
            // 手机号码
            this.lists[index].mobile = res.data.mobile;
            this.lists[index].mobileState = true;
          } else if (type == "3") {
            // 地区
            this.lists[index].fullAddress = res.data.fullAddress;
            this.lists[index].fullAddressState = true;
          }
        }
      });
    },

    // 批量发送短信
    handleBatchSend() {
      if (this.selectList && this.selectList.length > 0) {
        this.showSendMsg = true;
        this.preSendType = 2;
        var orderIds = [];
        this.selectList.forEach((item) => {
          orderIds.push(item.orderId);
        });
        this.conditionParam = {
          orderIds,
        };
      } else {
        this.$message.warning("请勾选订单！");
      }
    },

    // 按查询结果发送短信
    handleQueryResults() {
      this.showSendMsg = true;
      this.preSendType = 1;
      var paramData = JSON.parse(JSON.stringify(this.formData));
      if (paramData.wareIds) {
        paramData.wareId = paramData.wareIds;
      }
      delete paramData.wareIds;
      this.conditionParam = paramData;
    },

    // 批量打标签 type: 1 批量打标签 2 按查询结果打标签
    handleBatchLabel(type) {
      var param = {};
      this.batchLableType = type;
      if (type == "1") {
        // 批量打标签
        if (!this.selectList || this.selectList.length == 0) {
          this.$message.warning("请勾选订单！");
          return;
        }
        var pins = [];
        this.selectList.forEach((item) => {
          pins.push(item.pin);
        });
        console.log("this.selectList:", this.selectList);
        param = {
          pins: pins,
        };

        getCommonBuyerLabel(param).then((res) => {
          if (res.code == "1") {
            this.labelListArr = res.data.buyerLabelVOList;
            this.isShowLabelDialog = true;
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      } else {
        // 按查询结果打标签
        param = this.formData;
      }

      console.log("param:", param);

      Presellpop(this.formData).then((res) => {
        if (res.code == "1") {
          if (!res.data || res.data.length == "0") {
            this.$message.error("查询不到数据无法打标签，请重新选择条件！");
            return;
          }
          var paramX = {
            orderIds: res.data,
          };
          // var order = ''
          // for (var i =0; i<9999; i++) {
          //   order+= '100123385239,'
          // }
          //  var paramX = {
          //   orderIds: order
          // }

          getCommonBuyerLabel(paramX).then((res) => {
            if (res.code == "1") {
              this.labelListArr = res.data.buyerLabelVOList;
              this.isShowLabelDialog = true;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 生成人群
    handleCreateCrowd(type) {
      var param = {
        source: 2, // 来源 1订单发送 2预售订单发送
      };
      if (type == "1") {
        // 批量打标签
        if (!this.selectList || this.selectList.length == 0) {
          this.$message.warning("请勾选订单！");
          return;
        }
        param.orderIdStr = [];
        this.selectList.forEach((e) => {
          param.orderIdStr.push(e.orderId);
        });
        param.orderIdStr = param.orderIdStr.join(",");
      } else {
        // 按查询结果打标签
        param = {
          ...param,
          ...this.formData,
        };
        if (this.lists.length == 0) {
          this.$message.error("查询不到数据无法生成人群，请重新选择条件！");
          return;
        }
      }
      this.crowdForm = param;
      this.isShowCrowdDialog = true;
    },

    handleCloseLabel(obj) {
      console.log(obj);
      this.isShowLabelDialog = false;

      if (!obj.cancel) {
        let addArr = [];
        let delArr = [];
        var valIds = obj.idArr;

        valIds.forEach((item) => {
          let num = 0;
          this.labelListArr.forEach((item2) => {
            if (item == item2.id) {
              num = num + 1;
            } else {
            }
          });
          if (num == 0) {
            addArr.push(item);
          }
        });

        this.labelListArr.forEach((item) => {
          let number = 0;
          valIds.forEach((item2) => {
            if (item.id == item2) {
              number = number + 1;
            } else {
            }
          });
          if (number == 0) {
            delArr.push(item.id);
          }
        });
        let param = {
          addLabelIdList: addArr,
          delLabelIdList: delArr,
        };
        console.log("param====", param);

        var pinsList = [];
        this.selectList.forEach((item) => {
          // pinsList.push(item.realPin);
          pinsList.push(item.pin);
        });
        if (this.batchLableType == "1") {
          param.pins = pinsList;
          batchAddLabel(param).then((res) => {
            console.log(res);
            // 批量打标签
            if (res.code == "1") {
              this.$message.success("批量打标签成功！");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          // 按查询结果打标签
          Presellpop(this.formData).then((res) => {
            console.log(res);
            if (res.code == "1") {
              var data = {
                preSellOrderIds: res.data,
              };
              Object.assign(param, data);
              // if (param.wareIds != '') {
              //   param.wareIds = param.wareIds.split(',')
              // }else {
              //   param.wareIds = [];
              // }

              batchAddLabelByQuery(param).then((res) => {
                if (res.code == "1") {
                  this.$message.success("批量打标签成功！");
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      }
    },

    handleInsertBlack() {
      if (this.selectList && this.selectList.length > 0) {
        this.blackListDialog = false;
        var blackList = [];
        this.selectList.forEach((item) => {
          blackList.push(item.pin);
        });
        var param = {
          pins: blackList,
          type: 1,
        };
        insertBlack(param).then((res) => {
          if (res.code == "1") {
            this.$message.success(
              "添加成功" +
                res.data.sucessNum +
                "个; 失败" +
                res.data.fialNum +
                "个"
            );
          }
        });
      } else {
        this.$message.warning("请勾选订单哦！");
      }
    },
    handleSelectionChange(val) {
      console.log(val);
      this.selectList = val;
    },

    addOrderConfirm() {
      this.addOrderDialog = false;
      addOrder(this.addOrderForm).then((res) => {
        if (res.code == "1") {
          this.$message.success("添加订单成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleDetail(row, index) {
      console.log(row);
      // this.checkOrder = row.orderId;
      this.checkOrder = row;
      console.log("this.checkOrder:", this.checkOrder);
      this.showDetailDialog = true;
    },
    getDataList() {
      var param = {};
      Object.assign(param, this.formData, this.pagination);
      console.log("param", param);
      this.tableLoading = true;
      // if (this.timechage == true) {
      //   param.orderStartTimeStart = this.getDateStr(-30) + " 00:00:00";
      //   param.orderStartTimeEnd = this.getDateStr(0) + " 00:00:00";
      //   this.timechage = false;
      // }
      tbOrderPresell(param).then((res) => {
        this.tableLoading = false;
        if (res.code == "1") {
          this.lists = res.data.records;
          this.total = res.data.total;
        } else {
          this.lists = [];
        }
      });
    },
    handleCloseDetail() {
      this.showDetailDialog = false;
    },
    // drawerClose() {
    //   this.drawer = false;
    // },
    handleSendSMS(type) {
      if (type == 1) {
        // 发送短信
      } else {
        // 按查询结果发送短信
      }
      this.drawer = true;
    },
    searchForm(val) {
      this.formData = val;
      var index = 0;
      for (var i = 0; i < this.orderStatusType.length; i++) {
        if (val.orderState == this.orderStatusType[i].value) {
          index = i;
          break;
        }
      }
      this.tabItemActive = index;
      this.getDataList();
    },
    searchForm1(val) {
      if (this.isNavigate) {
        this.isNavigate = false;
        return;
      }
      this.pagination.current = 1;
      this.searchForm(val);
    },
    tabItemBtn(index) {
      this.tabItemActive = index;
      this.formData.orderState = this.orderStatusType[index].value;
      this.pagination.current = 1;
      this.pagination.size = 10;
      this.getDataList();
    },
    selectCheckboxChange() {
      let flag = true;
      this.lists.find(function (item) {
        if (!item.selectFlag) flag = false;
      });
      this.allSelectFlag = flag;
    },
    // 添加订单
    handleAddOrder() {
      this.addOrderDialog = true;
    },

    // 加入黑名单
    handleAddBlack() {
      if (this.selectList && this.selectList.length > 0) {
        this.blackListDialog = true;
      } else {
        this.$message.warning("请勾选订单哦！");
      }
    },

    handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.current = 1;
      this.getDataList();
    },

    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDataList();
    },
  },
};
</script>

<style lang="scss" scoped>
.show-box {
  position: relative;
  .hover-show {
    display: none;
    position: absolute;
    left: 0%;
    top: 50%;
    text-align: center;
    transform: translate(0, -50%);
    color: #fff;
    cursor: pointer;
    padding: 1px 10px;
    border-radius: 4px;
  }
  &:hover {
    .hover-show {
      display: inline-block;
    }
  }
}

/** 发送短信弹窗 */
/deep/.send-message-box .el-dialog__body {
  padding-left: 0;
  padding-top: 0;
}
/deep/.accurate_market .xiao_hug2 {
  left: 900px;
}
/** end */
.btn {
  cursor: pointer;
}
.input-form-box {
  background-color: #fff;
  padding: 24px 28px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  .el-form-item {
    margin-right: 40px;
  }
}
/** 弹窗相关样式 */
.btn-group {
  text-align: right;
  margin-top: 20px;
  .el-button {
    width: 98px;
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #999999;
    border-radius: 3px;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.order-line {
  span {
    display: inline-block;
    width: 72px;
    text-align: right;
  }
  .el-input {
    display: inline-block;
    width: 470px;
  }
}
.tipDialog {
  font-size: 14px;
  text-align: center;
  i {
    font-size: 24px;
    margin-right: 10px;
    vertical-align: middle;
  }
}
/** end */
.order-content {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
  margin-top: 20px;
  padding: 24px 28px;
  .btn_wrap {
    margin-bottom: 20px;
    .btn_left {
      float: left;
      .dingdanfasong_button1 {
        width: 98px;
        font-size: 14px;
        border-radius: 3px;
        border: 1px solid #fe4d45;
        height: 32px;
        color: #ffffff;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
      }
      .dingdanfasong_button2 {
        width: 98px;
        height: 32px;
        font-size: 14px;
        border-radius: 3px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
      .dingdanfasong_button3 {
        width: 98px;
        height: 32px;
        font-size: 14px;
        border-radius: 3px;
        color: #666666;
        border: 1px solid #dddddd;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
      .icon_sms {
        vertical-align: middle;
        margin-right: 4px;
        font-size: 14px;
      }
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        font-size: 14px;
        min-width: 90px;
        text-align: center;
        height: 32px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-right: 15px;
        cursor: pointer;
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          line-height: 32px;
          vertical-align: middle;
        }
      }
    }
    .btn_right {
      float: right;
      .dingdanfasong_button2 {
        width: 98px;
        height: 32px;
        font-size: 14px;
        border-radius: 3px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
      .dingdanfasong_button3 {
        width: 98px;
        height: 32px;
        font-size: 14px;
        border-radius: 3px;
        color: #666666;
        border: 1px solid #dddddd;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
      .el-button:hover {
        i {
          color: rgb(88, 130, 251);
        }
      }
      .setting-field {
        border: 1px solid #cccccc;
        text-align: center;
        height: 32px;
        width: 32px;
        display: inline-block;
        line-height: 32px;
        box-sizing: border-box;
        text-align: center;
        vertical-align: middle;
        margin-left: 10px;
      }
      .el-button--text {
        color: #666;
        border: 1px solid #ccc;
        padding: 0 12px;
        border-radius: 2px;
        height: 32px;
        line-height: 32px;
        vertical-align: middle;
      }
      i {
        font-size: 14px;
        color: #666;
      }
    }
    &:after {
      content: "";
      width: 0;
      height: 0;
      clear: both;
      display: block;
      overflow: hidden;
    }
  }
  .tab-hug {
    // border-bottom: 1px solid #ddd;
    .tab-item {
      display: inline-block;
      width: 106px;
      height: 36px;
      line-height: 36px;
      box-sizing: border-box;
      text-align: center;
      font-size: 14px;
      // font-family: "PingFang SC";
      font-weight: 400;
      color: #666666;
      border: 1px solid #ddd;
      // border-bottom: none;
      cursor: pointer;
      margin-right: 2px;
      &.active {
        font-weight: 500;
        position: relative;
        border-bottom: 1px solid #fff;
        border-top-width: 2px;
        &::after {
          content: "";
          display: block;
          height: 2px;
          width: 100%;
          background: #fff;
          position: absolute;
          left: 0;
          bottom: -1px;
        }
      }
    }
  }
  .table-content {
    box-sizing: border-box;
    margin-top: 20px;
    .table-head {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      background: rgba(240, 242, 246, 1);
      color: #3c4560;
      font-size: 14px;
      text-align: center;
    }
    .list {
      margin: 0;
      padding: 0;
      list-style: none;
      font-size: 14px;
      .item {
        margin-top: 10px;
        box-sizing: border-box;
        border: 1px solid rgba(240, 242, 246, 1);
        .top {
          display: flex;
          align-items: center;
          height: 30px;
          background-color: #f0f2f6;
          color: #333;
          font-size: 14px;
          .detail {
            cursor: pointer;
            color: #5882fb;
          }
        }
        .bottom {
          height: 90px;
          box-sizing: border-box;
          padding-left: 36px;
          text-align: center;
          background-color: #fff;
          color: #333;
          font-size: 14px;
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            border-right: 1px solid #f0f2f6;
            &:last-child {
              border: none;
            }
            p {
              margin: 0;
            }
          }
          .col1 {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            p {
              span:first-child {
                display: inline-block;
                width: 90px;
                text-align: right;
              }
              span:last-child {
                color: #5882fb;
              }
            }
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 18px;
    }
  }
}
</style
>>
